import Vue from 'vue';
import { api } from "../../services/Api.js";

export function update_absence({ state }, payload ){

    // adding token
    payload.token=state.appSettings.token

    // get active school
    var school = state.user_schools.find(school => school.active === 1);
    
    
    // make api call
    return api
    .post(school,"update_absence.php",payload)
    .then( result =>{ 
      return result;
    })
    .catch( error => {
      Vue.$toaster.toast("store: update_absence: "+error);
      return error;
    })

   
    
  }